<template>
  <section class="md:my-24 mt-5 grid gap-y-5 p-2">
    <div class="flex items-center justify-between">
      <h4>{{ $t("theme.admin.title") }}</h4>
    </div>

    <div class="bg-white rounded-lg border border-gray-300">
      <Table
        :slotData="themes"
        :columns="columns"
        :loading="loading"
        :filters="filters"
        :hasStatus="true"
        :params="params"
        customActions
        @onFilter="filterFor()"
        @onClearFilter="clearFilter()"
        @onToggleFilter="(e, type) => toggleFilter(e, 'name')"
        @onPaginate="paginate($event)"
      >
        <template #filters>
          <InputText v-if="filterType === 'name'" v-model="filters.name" />
        </template>

        <template #actions="{ columnProps }">
          <Button
            icon="pi pi-eye"
            class="btn-simple"
            @click.prevent="openItem(columnProps.data)"
          />
        </template>
      </Table>
    </div>

    <Dialog
      v-model:visible="openDialog"
      :header="$t('theme.admin.dialog.title') + theme?.organization?.name + ' - ' + theme?.subdomain"
      :draggable="false"
      :style="{ width: '80vw', maxWidth: '1080px' }"
      modal
    >
      <ThemeInfo
        v-if="openDialog"
        :org-id="theme?.organization?.id"
        :domain="theme.subdomain"
      />
    </Dialog>
  </section>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { ThemeRest } from "@/services/rest/themes.rest";
import { GoToRoute } from "@/utils/go-to.util";
import { removeItemSessionStorage } from "@/utils/save-storage.util";
import { defineAsyncComponent, defineComponent } from "vue";
import { columns } from "./theme.utils";

const ThemeInfo = defineAsyncComponent(() => import("./info.vue"));

export default defineComponent({
  name: "themes",
  components: { ThemeInfo },
  computed: {
    rest(): ThemeRest {
      return new ThemeRest();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  data() {
    return {
      columns: columns as any,
      loading: true as boolean,
      pageLoader: true as boolean,
      openDialog: false as boolean,
      themes: [] as any,
      theme: {} as any,
      searchFor: "" as string,
      filters: {
        isCleareable: false,
        name: null,
      } as any,
      filterType: "" as string,
      params: new QueryParams(),
      emptyState: {
        image: "empty_courses.svg",
        description: this.$t("theme.empty.description"),
      } as any,
    };
  },
  mounted() {
    this.themesPaginated();
    removeItemSessionStorage("classData");
  },
  methods: {
    toggleFilter(event: any, type: string): void {
      this.filterType = type;
    },
    filterFor(): void {
      this.filters.isCleareable = this.isCleareable();
      var params = new QueryParams();
      params.name = this.filters.name;
      this.setPage(params);
    },
    clearFilter(): void {
      this.filters.isCleareable = false;
      this.filters.name = "";
      this.themesPaginated();
    },
    isCleareable(): boolean {
      return this.filters.name !== "";
    },
    paginate(event: { page: number; rows: number }): void {
      const params = new QueryParams(event.page, event.rows);
      this.setPage(params);
    },
    setPage(queryParams: QueryParams): void {
      this.rest
        .getAllThemes(queryParams)
        .then((response) => {
          this.themes = response.content;
          this.params.total = response.total;
        })
        .finally(() => {
          this.loading = false;
          this.pageLoader = false;
        });
    },
    themesPaginated(): void {
      const page = this.params.page;
      const size = this.params.size;
      const params = new QueryParams(page, size);
      this.setPage(params);
    },
    openItem(item): void {
      this.openDialog = true;
      this.theme = item;
    },
  },
});
</script>
